import React, { useState, useEffect } from "react";
import { Link, useNavigate } from "react-router-dom";
import styled from "styled-components";
import { Button, Form } from "react-bootstrap";
import axios from "axios";
import { useUser } from "./UserContext";
import { ToastContainer, toast } from "react-toastify";
import apiClient from "./apiClient";
import { useLocation } from "react-router-dom";

const Container = styled.div`
  display: flex;
  justify-content: center;
  align-items: center;
  height: 70vh;
  background-color: #f5f5f5;
`;

const LoginForm = styled(Form)`
  width: 500px;
  padding: 30px;
  border-radius: 10px;
  box-shadow: 0 0 10px 0 rgba(0, 0, 0, 0.1);
  background-color: white;
`;

const LoginButton = styled(Button)`
  width: 100%;
`;

const SpacedFormGroup = styled(Form.Group)`
  margin-bottom: 5px;
`;

const LinkForm = styled.div`
  cursor: pointer;
  color: #007bff;
  text-align: right;
  margin-bottom: 10px;
`;

const API_BASE_URL = process.env.REACT_APP_API_BASE_URL;

const LoginPage = () => {
  const [userID, setUserID] = useState("");
  const [password, setPassword] = useState("");
  const navigate = useNavigate();
  const location = useLocation();
  const { setUser } = useUser();

  const handleSubmit = (event) => {
    event.preventDefault();
    login(userID, password);
  };
  useEffect(() => {
    if (location.state?.message) {
      toast.success(location.state.message);
    }
  }, [location.state]);

  const login = async (userID, password) => {
    try {
      const response = await axios.post(`${API_BASE_URL}/api/accounts/login/`, {
        username: userID,
        password: password,
      });
      if (response.data.access) {
        setUser({ id: response.data.user_id, userID: userID, username: response.data.username });
        apiClient.setToken(response.data.access, response.data.refresh);
        navigate(location.state?.returnTo === "/Register" ? "/Register" : "/MyPage");
      } else {
        // accessがない場合のエラーハンドリング
        console.error("ログインに失敗しました。");
      }
      return response.data;
    } catch (error) {
      const errorCode = error?.response?.status;

      if (errorCode === 401) {
        toast.warn("ユーザーIDまたはパスワードが違います。");
      } else if (errorCode === 400) {
        toast.info("入力内容に誤りがあります。");
      } else if (errorCode === 500) {
        toast.error("サーバエラーが発生しました。しばらくしてから再度お試しください。");
      } else {
        toast.error("予期せぬエラーが発生しました。");
      }
    }
  };

  const handleUserIDChange = (event) => {
    setUserID(event.target.value);
  };

  const handlePasswordChange = (event) => {
    setPassword(event.target.value);
  };

  return (
    <React.StrictMode>
      <Container>
        <LoginForm onSubmit={handleSubmit}>
          {location.state?.returnTo === "/Register" && <p>ログインすると、下書きの夢の続きを書けます。</p>}
          <SpacedFormGroup controlId="formBasicUserID">
            <Form.Label>ユーザーID</Form.Label>
            <Form.Control type="userID" placeholder="ユーザーID" value={userID} onChange={handleUserIDChange} />
          </SpacedFormGroup>

          <SpacedFormGroup controlId="formBasicPassword">
            <Form.Label>パスワード</Form.Label>
            <Form.Control type="password" placeholder="パスワード" value={password} onChange={handlePasswordChange} />
          </SpacedFormGroup>

          <LinkForm onClick={() => navigate("/ForgotPassword")}>パスワードを忘れた方はこちら</LinkForm>

          <Button variant="primary" type="submit" size="lg" className="w-100 text-center d-flex align-items-center justify-content-center" style={{ minWidth: "120px", whiteSpace: "nowrap", fontSize: "1.2rem", backgroundColor: "#282c34", color: "#ffffff", borderColor: "#282c34" }}>
            ログイン
          </Button>
        <p style={{ marginTop: 20 }}><Link to="/MemberRegisterView">初めての方は会員登録へ</Link></p>
        </LoginForm>
      </Container>
      <ToastContainer position="top-center" autoClose={3000} />
    </React.StrictMode>
  );
};

export default LoginPage;
